module.exports = __webpack_public_path__ + "static/media/nonord-c-4.8a52cdb3.mp3";